<template>
    <ThLink
        v-bind="bind"
        class="header-link"
        @click="scrollToTop"
    >
        <slot name="default"></slot>
    </ThLink>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import type { LinkFragment } from '@/graphql/api'
import { useCmsLink } from '@/components/cms'
import { getTimeout, getWindow } from '@/helpers/globals'

import ThLink from '@/components/ui/buttons/ThLink.vue'

const { link } = defineProps<{
    link: LinkFragment
}>()

const bind = useCmsLink(toRef(() => link))
const window = getWindow()
const { setTimeout } = getTimeout() || { setTimeout: undefined }

const scrollToTop = () => {
    setTimeout?.(() => {
        window?.scrollTo({ top: 0, behavior: 'smooth' })
    })
}
</script>
